module.exports = __webpack_public_path__ + "static/parade-2020-house36-b1912ee1f1ecc50a25484e6b8024ff1f.jpg";